import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  ExtendedFlex,
} from '../../coreui';

import tooltipData from './headerData';
import Header from '../../ioDetails/components/header';
import HeaderHighlight from '../../ioDetails/components/headerHighlight';

// eslint-disable-next-line
class PPHeader extends React.Component {
  render() {
    const {
      io,
    } = this.props;

    let range = null;
    if (io.estimatedReturnLow && io.estimatedReturnHigh) {
      range = `${io.estimatedReturnLow}% - ${io.estimatedReturnHigh}%`;
    }

    const irrLabel = (
      <ExtendedBox>
        Target IRR
        <br />
        {range}
      </ExtendedBox>
    );

    let equityMultipleLabel = 'Target Equity Multiple';
    if (io.targetEquityMultipleLow && io.targetEquityMultipleHigh) {
      equityMultipleLabel = (
        <ExtendedFlex
          flexDirection="column"
          w={1}
        >
          <ExtendedBox>
            Target Equity Multiple
          </ExtendedBox>
          <ExtendedBox>
            {io.targetEquityMultipleLow} - {io.targetEquityMultipleHigh}
          </ExtendedBox>
        </ExtendedFlex>
      );
    }

    let cocRange = io.estimatedCashOnCashLow !== null && `${io.estimatedCashOnCashLow}%`;
    if (io.estimatedCashOnCashHigh) {
      cocRange = `${cocRange ? `${cocRange} - ` : ''} ${io.estimatedCashOnCashHigh}%`;
    }

    const highlights = (
      <ExtendedFlex
        flexDirection="row"
      >
        <HeaderHighlight
          id="irr"
          tooltip={tooltipData.irr}
          label={irrLabel}
          highlight={(io.targetReturn) ? `${io.targetReturn}%` : null}
          showAsterisk={io.showHighlightAsterisk}
        />
        {
          cocRange &&
          <HeaderHighlight
            id="coc"
            tooltip={tooltipData.coc}
            label="Target Cash On Cash"
            highlight={cocRange}
            showAsterisk={io.showHighlightAsterisk}
          />
        }
        <HeaderHighlight
          id="equityMultiple"
          tooltip={tooltipData.multiple}
          label={equityMultipleLabel}
          highlight={io.targetEquityMultiple}
          mr={[5, 10, 10, 40, 0]}
          showAsterisk={io.showHighlightAsterisk}
        />
      </ExtendedFlex>
    );
    const subTitle = (io.management && io.management[0] && io.management[0].label) ? `Sponsored by ${io.management[0].label}` : null;

    return (
      <Header
        title={io.label}
        subTitle={subTitle}
        highlights={highlights}
      />
    );
  }
}

PPHeader.propTypes = {
  io: PropTypes.any,
};

export default PPHeader;
